var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"imglist"},_vm._l((_vm.list),function(item,i){return _c('Game',{key:item.game_id,attrs:{"game":item,"index":i,"stat-params":_vm.statParams}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }